import * as GA from 'modules/app/services/ga/constants';
import GtagService from 'modules/app/services/ga/GtagService';

import { ENABLE_VOD } from './constants';

const common = {
  event: GA.EVENTS.INTERACTION,
  event_category: GA.CATEGORIES.CLUB_ADMIN_CONTENT
};

const INFO_ANALYTICS_EVENTS = GtagService.createEvents({
  common: {
    ...common,
    event_action: GA.ACTIONS.LIVE.CLICK_INFO
  },
  [GA.LABELS.TITLE]: {
    event_label: GA.LABELS.TITLE
  },
  [GA.LABELS.DESCRIPTION]: {
    event_label: GA.LABELS.DESCRIPTION
  }
});

const DATE_ANALYTICS_EVENTS = GtagService.createEvents({
  common: {
    ...common,
    event_action: GA.ACTIONS.LIVE.CLICK_DATE
  },
  [GA.LABELS.DATE]: {
    event_label: GA.LABELS.DATE
  },
  [GA.LABELS.HOUR]: {
    event_label: GA.LABELS.HOUR
  },
  [GA.LABELS.MINUTE]: {
    event_label: GA.LABELS.MINUTE
  },
  [GA.LABELS.COUNTRY]: {
    event_label: GA.LABELS.COUNTRY
  },
  [GA.LABELS.TIMEZONE]: {
    event_label: GA.LABELS.TIMEZONE
  }
});

const ANALYTICS_EVENTS = GtagService.createEvents({
  common,
  [GA.ACTIONS.LIVE.CLICK_METHOD]: {
    event_action: GA.ACTIONS.LIVE.CLICK_METHOD
  },
  [GA.ACTIONS.LIVE.CLICK_THUMBNAIL]: {
    event_action: GA.ACTIONS.LIVE.CLICK_THUMBNAIL,
    event_label: GA.LABELS.UPLOAD
  },
  [GA.ACTIONS.LIVE.CLICK_AFTER_STREAM]: {
    event_action: GA.ACTIONS.LIVE.CLICK_AFTER_STREAM
  },
  [GA.ACTIONS.LIVE.CLICK_CREATE]: {
    event_action: GA.ACTIONS.LIVE.CLICK_CREATE,
    event_label: GA.LABELS.LIVE
  },
  [GA.ACTIONS.LIVE.CLICK_ACCESS_PANEL]: {
    event_action: GA.ACTIONS.LIVE.CLICK_ACCESS_PANEL,
    event_label: GA.LABELS.ACCESS_PANEL
  }
});

export const clickLiveMethod = (provider) => {
  const event = ANALYTICS_EVENTS[GA.ACTIONS.LIVE.CLICK_METHOD];

  event &&
    window.dataLayer?.push({
      ...event,
      event_label: provider
    });
};

export const clickLiveTitle = () => {
  const event = INFO_ANALYTICS_EVENTS[GA.LABELS.TITLE];

  event && window.dataLayer?.push(event);
};

export const clickLiveDescription = () => {
  const event = INFO_ANALYTICS_EVENTS[GA.LABELS.DESCRIPTION];

  event && window.dataLayer?.push(event);
};

export const clickLiveThumbnail = () => {
  const event = ANALYTICS_EVENTS[GA.ACTIONS.LIVE.CLICK_THUMBNAIL];

  event && window.dataLayer?.push(event);
};

export const clickLiveAfterStream = (enableVodPlayback) => {
  const event = ANALYTICS_EVENTS[GA.ACTIONS.LIVE.CLICK_AFTER_STREAM];
  const label =
    enableVodPlayback === `${ENABLE_VOD.YES}` ? GA.LABELS.YES : GA.LABELS.NO;

  event &&
    window.dataLayer?.push({
      ...event,
      label
    });
};

export const clickLiveDate = () => {
  const event = DATE_ANALYTICS_EVENTS[GA.LABELS.DATE];

  event && window.dataLayer?.push(event);
};

export const clickLiveHourMinute = () => {
  const event = DATE_ANALYTICS_EVENTS[`${GA.LABELS.HOUR}:${GA.LABELS.MINUTE}`];

  event && window.dataLayer?.push(event);
};

export const clickLiveCountry = () => {
  const event = DATE_ANALYTICS_EVENTS[GA.LABELS.COUNTRY];

  event && window.dataLayer?.push(event);
};

export const clickLiveTimezone = () => {
  const event = DATE_ANALYTICS_EVENTS[GA.LABELS.TIMEZONE];

  event && window.dataLayer?.push(event);
};

export const clickCreate = () => {
  const event = ANALYTICS_EVENTS[GA.ACTIONS.LIVE.CLICK_CREATE];

  event && window.dataLayer?.push(event);
};

export const clickAccessPanel = () => {
  const event = ANALYTICS_EVENTS[GA.ACTIONS.LIVE.CLICK_ACCESS_PANEL];

  event && window.dataLayer?.push(event);
};
